import React from 'react';
import Modal from './CustomModal';
// styles
import crossbutton from '../images/icons/cross-white.svg';
import '../scss/_listingModal.scss';
import PhotoCarousel from './PhotoCarousel';

class fullCarouselModal extends React.Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal = () => {
        this.props.toggle('fullCarouselModal');
    }

    renderPhotoCarousel = (photo, i) => {
        const { listing } = this.props;
        const showCaption = listing.ListingPhotosCaptions[i] != null;
        const captionStyle = {
            display: showCaption ? 'show' : 'none'
        };
        const caption = listing.ListingPhotosCaptions[i];
        return <div key={photo} className='photo-container'>
            <img src={photo} alt={photo} />
            <p className="legend" style={captionStyle} >{caption}</p>
        </div>;
    }

    render() {
        const { listing, selectedItem = 0 } = this.props;
        if (!listing) return null;
        const externalCloseBtn = <button className="close dyna-close" onClick={() => this.closeModal()}>
            <img src={crossbutton} alt="close" />
        </button>;

        return <Modal modalIsOpen={this.props.modalIsOpen}
            external={externalCloseBtn}
            handleClose={() => this.closeModal()}
            className="dyna-modal modal-xxl mg-top-0 carousel-modal"
            bodyClass="pd-none" >
            <div className="fullCarouselModal">
                <PhotoCarousel listing={listing} photoRenderer={this.renderPhotoCarousel} carouselProps={selectedItem} />
            </div>
        </Modal>
    }
}


export default fullCarouselModal;